import { createStandaloneToast } from "@chakra-ui/toast";
import { Get, Post, url } from "api";
import { InvoiceData } from "views/admin/invoices/types";

async function getInvoices({
  page,
  pageSize,
  filters,
}: {
  page: number;
  pageSize: number;
  filters?: Record<string, any>;
}): Promise<{ data: InvoiceData[]; total: number }> {
  try {
    const fullUrl = new URL(url + "/manage/partners/invoice-status");
    fullUrl.searchParams.append("limit", pageSize.toString());
    fullUrl.searchParams.append("page", page.toString());

    //loop filters and append to url
    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        fullUrl.searchParams.append(key, filters[key]);
      }
    });

    const response = await Get(fullUrl.toString());
    return {
      data: response?.items ?? [],
      total: response?.pagination?.total ?? 0,
    };
  } catch (error) {
    console.warn("Error fetching invoices: ", error);
  }
}

async function updatePaymentStatus(data: InvoiceData) {
  try {
    const response = await Post("/manage/partner/invoice-status-update", {
      ...data,
    });

    return {
      success: !response.err,
    };
  } catch (error) {
    console.error("Error updating payment status: ", error);
  }
}

export async function createNewInvoiceStatus(data: {
  partnerId: number;
  companyName: string;
  amount: number;
  processStatus: string;
  paymentStatus: string;
  range: string;
}) {
  try {
    const response = await Post("/manage/partners/invoice-status", {
      ...data,
      s3Location: null,
    });

    if (response.err) {
      throw new Error(response.err);
    }
  } catch (error) {
    console.error("Error creating new invoice status: ", error);
  }
}

export { getInvoices, updatePaymentStatus };
